import React, { useEffect, useRef, useCallback } from 'react'
import t from '~t'
import { useDispatch, useSelector } from 'react-redux'
import { draftLoad } from '~data/actions/bookmarks'
import { getDraftItem, getDraftStatus } from '~data/selectors/bookmarks'

import { Button, Icon, Preloader } from '~ui'

export default function BookmarksAddSave({ tab = {}, spaceId, search, onEdit }) {
    const dispatch = useDispatch()
    const status = useSelector(state => getDraftStatus(state, tab.link))
    const item = useSelector(state => getDraftItem(state, tab.link))

    const load = useCallback(
        (details = {}) => {
            dispatch(
                draftLoad(tab.link, {
                    item: {
                        ...tab,
                        collectionId: parseInt(spaceId)
                    },
                    autoCreate: false,
                    ...details
                })
            )
        },
        [dispatch, tab, spaceId]
    )

    const onEditClick = useCallback(() => {
        onEdit([item])
    }, [onEdit, item])

    useEffect(() => {
        load({})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tab])

    const prevStatus = useRef(status)
    useEffect(() => {
        if (prevStatus.current == 'saving' && status == 'loaded')
            onEditClick()
        prevStatus.current = status
    }, [status, onEditClick])

    const onAddClick = useCallback(() => {
        load({
            autoCreate: true,
            preventDuplicate: false //no need to check for duplicate, because we already know that it's new
        })
    }, [load])

    switch (status) {
        case 'saving':
            return (
                <Button variant='ghost' className={'ui-bm-tab-btn'}>
                    <Preloader />
                    <span className={'ui-bm-tab-label hide-on-small-body'}>{t.s('save')}…</span>
                </Button>
            )

        case 'loaded':
            return (
                <Button
                    className={'ui-bm-tab-btn'}
                    variant='active'
                    title={t.s('edit')}
                    onClick={onEditClick}>
                    <Icon name='check_active' />
                    <span className={'ui-bm-tab-label hide-on-small-body'}>{!search && t.s('saved')}</span>
                </Button>
            )

        default:
            return (
                <Button
                    className={'ui-bm-tab-btn'}
                    data-init={status == 'loading' || status == 'idle'}
                    variant='primary'
                    title={t.s('save')}
                    onMouseDown={onAddClick}>
                    <Icon name='add' />
                    <span className={'ui-bm-tab-label hide-on-small-body'}>{!search && t.s('save')}</span>
                </Button>
            )
    }
}
